import React, { useEffect, useState, useCallback } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { affiliateApi } from "../../lib/api";
import AffiliateNav from "./AffiliateNav";
import { PendingPeriodCard, PayrollHistoryList } from "../../components/affiliate/PayrollViews";

export default function AffiliatePayroll() {
  const [me, setMe] = useState(null);
  const [current, setCurrent] = useState(null);
  const [history, setHistory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [unauthed, setUnauthed] = useState(false);

  const load = useCallback(() => {
    setLoading(true);
    Promise.all([affiliateApi.me(), affiliateApi.payrollCurrent(), affiliateApi.payrollHistory()])
      .then(([aff, cur, hist]) => { setMe(aff); setCurrent(cur); setHistory(hist); })
      .catch(() => setUnauthed(true))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  if (unauthed) return <Navigate to="/affiliate/login" replace />;
  if (loading || !me) {
    return <div className="min-h-screen flex items-center justify-center bg-[#0A0E17]"><Loader2 className="h-7 w-7 text-amber-400 animate-spin" /></div>;
  }

  return (
    <div className="min-h-screen bg-[#0A0E17] text-slate-200" data-testid="affiliate-payroll-page">
      <AffiliateNav affiliateName={me.name} />
      <div className="px-6 py-6 max-w-6xl mx-auto space-y-6">
        <div>
          <h2 className="text-[18px] font-bold text-white">Payroll</h2>
          <p className="text-[13px] text-slate-500">Your commission is calculated on a weekly Friday-through-Thursday cycle. This week's numbers update live and are paid out the following Friday.</p>
        </div>
        <PendingPeriodCard period={current} />
        <PayrollHistoryList history={history} />
      </div>
    </div>
  );
}
